module.exports = __webpack_public_path__ + "media/images/coaching-knowledge-5904e055d57d864e67c8373a1477c604.svg";